import { BsArrowLeft } from "react-icons/bs";
import { HStack, Text } from "@wootingkb/component-library";
import { useRouter } from "next/router";
import { Trans } from "@lingui/react/macro";

export default function HomeNavigation({ toHistory }: { toHistory?: boolean }) {
  const router = useRouter();

  return (
    <HStack
      className="mb-4 w-fit cursor-pointer items-center text-sm"
      onClick={() => router.push(toHistory ? "/my/orders" : "/")}
    >
      <BsArrowLeft />
      <Text size="sm" className="user-select-none ml-2 italic hover:underline">
        {toHistory ? (
          <Trans id="Home_nav_back_to_order_history">
            Back to order history
          </Trans>
        ) : (
          <Trans id="Home_nav_go_back_home">Go back home</Trans>
        )}
      </Text>
    </HStack>
  );
}
